<template>
  <section
    v-if="$screen.portrait"
    class="fixed inset-x-0 bottom-0 z-50 block border-t border-ontick-carbon-500 bg-ontick-graphite-500 shadow-lg md:hidden"
  >
    <div
      class="bg-ontick-steel-600 px-6 transition-all duration-300 ease-in-out"
      :style="active_menu.search ? 'height:330px' : 'height:0px'"
    >
      <div v-show="active_menu.search" class="flex rounded-md pt-6 shadow-sm">
        <div class="relative flex w-full">
          <input
            @keyup.enter="
              search.length != 0
                ? searchMarketplace(search)
                : getMarketplace('reset_filter')
            "
            v-model="search"
            type="search"
            class="block w-full rounded-none rounded-l-md bg-ontick-graphite-500 pl-6 text-white sm:text-sm"
          />
        </div>
        <button
          @click="
            search.length != 0
              ? searchMarketplace(search)
              : getMarketplace('reset_filter')
          "
          class="focus:outline-none relative -ml-px inline-flex items-center space-x-2 rounded-r-md bg-ontick-graphite-500 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-ontick-graphite-600 hover:text-ontick-blue-500"
        >
          <dl v-show="!submitted" v-html="$icons.search"></dl>
          <dl v-show="submitted" v-html="$icons.loading"></dl>
        </button>
      </div>
    </div>

    <div
      class="bg-ontick-steel-500 transition-all duration-300 ease-in-out"
      :style="active_menu.order ? 'height:460px' : 'height:0px'"
    >
      <div
        v-show="active_menu.order"
        class="relative -space-y-px rounded-md px-3 py-3"
      >
        <label
          v-for="(item, planIdx) in optionsSelect"
          :key="planIdx"
          class="flex cursor-pointer rounded-md px-3 py-3"
          :class="[
            planIdx === indexMenu
              ? 'bg-ontick-graphite-500 '
              : 'bg-ontick-steel-500 ',
          ]"
          @click="
            optionSelected(item, planIdx);
            active_menu.order = !active_menu.order;
          "
        >
          <div class="flex items-center text-sm">
            <span class="ml-3 font-medium text-white">{{ item.label }}</span>
          </div>
        </label>
      </div>
    </div>

    <div
      class="bg-ontick-steel-500 transition-all duration-300 ease-in-out"
      :style="active_menu.filter ? 'height:330px' : 'height:0px'"
    >
      <div class="py-3" v-show="active_menu.filter">
        <!-- <filters-marketplace /> -->
      </div>
    </div>

    <div class="flex justify-between">
      <a
        @click="menuMobile(item)"
        v-for="item in menu_buttons"
        :key="item.label"
        href="#"
        class="inline-block w-full justify-center pt-2 pb-1 text-center"
      >
        <span
          class="inline-block"
          :class="item.active ? 'text-ontick-blue-500' : 'text-gray-400'"
          v-html="item.icon"
        ></span>

        <span
          :class="item.active ? 'text-white' : 'text-gray-400'"
          class="tab tab-home block text-xs"
          >{{ item.label }}</span
        >
      </a>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      search: "",
      submitted: false,
      active_menu: {
        search: false,
        to_view: false,
        order: false,
        filter: false,
      },
      optionsSelect: [
        {
          label: "Ativo A a Z",
          type: "asc",
          criterion: "alpha",
        },
        {
          label: "Ativo Z a A",
          type: "desc",
          criterion: "alpha",
        },
        {
          label: "Maior Retorno",
          type: "desc",
          criterion: "return",
        },
        {
          label: "Menor Retorno",
          type: "asc",
          criterion: "return",
        },
        {
          label: "Maior Fator de Lucro",
          type: "desc",
          criterion: "profit_factor",
        },
        {
          label: "Menor Fator de Lucro",
          type: "asc",
          criterion: "profit_factor",
        },
        {
          label: "Maior Drawdown",
          type: "desc",
          criterion: "drawdown",
        },

        {
          label: "Menor Drawdown",
          type: "asc",
          criterion: "drawdown",
        },
        {
          label: "Maior Tx. Acerto",
          type: "desc",
          criterion: "win_ratio",
        },
        {
          label: "Menor Tx. Acerto",
          type: "asc",
          criterion: "win_ratio",
        },
      ],

      indexMenu: null,

      menu_buttons: [
        {
          label: "Buscar",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path></svg>`,
        },

        {
          label: "Ordenar",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path></svg>`,
        },
        {
          label: "Filtrar",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path></svg>`,
        },

        {
          label: "Favoritos",
          active: false,
          icon: `<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path></svg>`,
        },
      ],
    };
  },

  components: {
    // FiltersMarketplace: () =>
    //   import(
    //     "@/app/modules/marketplace/components/products/marketplace-filters.component.vue"
    //   ),
  },

  methods: {
    ...mapActions({
      orderMarketplace: "marketplace/orderMarketplace",
      getMarketplaceInputSearch: "marketplace/getMarketplaceInputSearch",
      getMarketplace: "marketplace/getMarketplace",
      getMarketplaceFavorite: "marketplace/getMarketplaceFavorite",
    }),

    menuMobile(value) {
      if (value.label == "Buscar") {
        this.active_menu.search = !this.active_menu.search;
        this.active_menu.to_view = false;
        this.active_menu.order = false;
        this.active_menu.filter = false;
        this.activeMenu(value);
      } else if (value.label == "Visualizar") {
        this.active_menu.to_view = !this.active_menu.to_view;
        this.active_menu.order = false;
        this.active_menu.filter = false;
        this.active_menu.search = false;
        this.activeMenu(value);
      } else if (value.label == "Ordenar") {
        this.active_menu.order = !this.active_menu.order;
        this.active_menu.to_view = false;
        this.active_menu.filter = false;
        this.active_menu.search = false;
        this.activeMenu(value);
      } else if (value.label == "Filtrar") {
        this.active_menu.filter = !this.active_menu.filter;
        this.active_menu.search = false;
        this.active_menu.to_view = false;
        this.active_menu.order = false;
        this.activeMenu(value);
      } else if (value.label == "Favoritos") {
        this.$emit("favorite");
        this.activeMenu(value);
      }
    },

    activeMenu(value) {
      this.menu_buttons.forEach((item) => {
        item.active = false;
      });

      value.active = value.active === true ? false : true;
    },

    searchMarketplace(value) {
      this.submitted = true;
      this.getMarketplaceInputSearch(value.toUpperCase());
      setTimeout(() => {
        this.submitted = false;
      }, 1000);
    },

    optionSelected(event, item) {
      this.orderMarketplace(event);
    },
  },
};
</script>

<style></style>
